import { useGlobalState } from '@vindr/workspace-core/contexts/GlobalContext';
import { PERMISSION_LOADING } from '@vindr/services/constants/common.constant';
import { LoadingIndicatorProgress } from '@vindr/ui';
import { useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({
  permissions,
  children,
  path,
}: {
  permissions?: string[];
  children: JSX.Element;
  path: string;
}) => {
  const { keycloak } = useGlobalState();
  const [authInit, setAuthInit] = useState(keycloak.initiated);
  const location = useLocation();

  useEffect(() => {
    if (!keycloak.initiated) {
      keycloak.init(() => {
        setAuthInit(true);
      });
    }
  }, []);

  const hasPermission = permissions && permissions?.length > 0;
  const permissionsList = keycloak.getPermissions();

  const hasPermissionInAccount = useMemo(() => {
    if (!permissionsList || permissionsList?.length === 0) return null;
    if (!hasPermission) return false;

    return keycloak.hasAllOfPerm(permissions);
  }, [hasPermission, permissions, permissionsList]);

  if (!authInit || permissionsList?.includes(PERMISSION_LOADING))
    return <LoadingIndicatorProgress className="h-full w-full bg-black" />;

  if (hasPermissionInAccount) return children;
  if (location.pathname.endsWith(path)) return <Navigate to="/no-permission" />;
  return null;
};

export default ProtectedRoute;
